<template>
    <div class="container-fluid p-admin-coupons">
        <div class="card">
            <div class="card-header">クーポンコード一覧</div>
            <div class="card-body pt-2">
                <div class="d-block d-md-flex justify-content-between align-items-center mb-3">
                    <div class="d-block d-md-flex flex-wrap align-items-center">
                        <div class="mt-2 mr-0 mb-2 mr-md-2 mb-md-0">
                            <div class="input-group input-group-sm">
                                <select
                                    v-model="search.coupon_id"
                                    @change="onChangeSearchCoupon"
                                    class="form-control">
                                    <option :value="null">クーポンで検索</option>
                                    <option
                                        v-for="coupon in coupons"
                                        :value="coupon.id">
                                        {{ `${coupon.name}（${coupon.campaign.name}）` }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="mt-2 mr-0 mb-2 mr-md-2 mb-md-0">
                            <div class="c-freeword input-group input-group-sm">
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="フリーワード"
                                    style="min-width: 100px;"
                                    v-model="search.freeword">
                                <div class="input-group-append">
                                    <div class="c-freeword__btn input-group-text"
                                         @click="onChangeSearchFreeword">検索
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-block d-md-flex align-items-center">
                            <div class="mt-2 mb-2 ml-md-2 mb-md-0">
                                <span class="small">作成日時</span>
                            </div>
                            <div class="mt-2 mb-2 ml-md-2 mb-md-0">
                                <div class="input-group input-group-sm">
                                    <input
                                        type="date"
                                        class="form-control"
                                        @change="onChangeSearchCreatedAtGte"
                                        style="min-width: 100px;"
                                        v-model="search.created_at_gte">
                                </div>
                            </div>
                            <span class="small mt-2 ml-2">〜</span>
                            <div class="mt-2 mb-2 ml-md-2 mb-md-0">
                                <div class="input-group input-group-sm">
                                    <input
                                        type="date"
                                        class="form-control"
                                        @change="onChangeSearchCreatedAtLte"
                                        style="min-width: 100px;"
                                        v-model="search.created_at_lte">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    v-if="couponCodes !== null"
                    class="row justify-content-center adminCouponCodesTableWrapper">
                    <div class="col-md-12">
                        <b-table
                            striped
                            hover
                            :items="couponCodes"
                            :fields="fields"
                            :sort-by.sync="$store.state.adminCouponCodes.sortBy"
                            :sort-desc.sync="$store.state.adminCouponCodes.sortDesc"
                            @sort-changed="fetchCouponCodes"
                            :responsive="true"
                            class="table-bordered m-table">
                            <template v-slot:cell(is_enabled)="data">
                                <span v-if="data.item.is_enabled === 1" class="text-success">有効</span>
                                <span v-else class="text-muted">無効</span>
                            </template>

                            <template v-slot:cell(coupon_name)="data">
                                <div>{{ data.item.coupon_name }}</div>
                                <div class="small text-muted">{{ data.item.campaign_name }}</div>
                            </template>

                            <template v-slot:cell(use_limit)="data">
                                <span>{{ data.item.use_limit || '-' }}</span>
                            </template>

                            <template v-slot:cell(user_coupons_count)="data">
                                <span>{{ data.item.user_coupons_count || 0 }}</span>
                            </template>

                            <template v-slot:cell(remarks)="data">
                                <div class="remarks d-flex">{{ data.item.remarks }}</div>
                            </template>

                            <template v-slot:cell(created_at)="data">
                                <div class="u-palt">
                                    <span>
                                        {{ helper.dateForHuman(data.item.created_at, 'Asia/Tokyo', {simpleYear: true}) }}
                                    </span>
                                    <span
                                        class="font-weight-bold"
                                        :class="helper.dayForHumanCSS(data.item.created_at.start_time , 'Asia/Tokyo')">
                                        {{ helper.dayForHuman(data.item.created_at.start_time, 'Asia/Tokyo', {bracket: true}) }}
                                    </span>
                                    <span>{{ helper.timeForHuman(data.item.created_at, 'Asia/Tokyo') }}</span>
                                </div>
                            </template>

                            <template v-slot:cell(links)="data">
                                <b-button
                                    type="button"
                                    variant="yokumiru-blue"
                                    class="btn-sm m-2"
                                    @click="openModalAdminEditCouponCode(data.item)">
                                    編集
                                </b-button>
                                <b-button
                                    type="button"
                                    variant="danger"
                                    class="btn-sm m-2"
                                    :disabled="data.item.user_coupons_count > 0"
                                    @click="openModalAdminDeleteCouponCode(data.item)">
                                    削除
                                </b-button>
                            </template>
                        </b-table>

                        <div class="d-flex flex-wrap justify-content-between align-items-center">
                            <b-pagination
                                :total-rows="$store.state.adminCouponCodes.total"
                                :per-page="$store.state.adminCouponCodes.per_page"
                                v-model="$store.state.adminCouponCodes.current_page"
                                @change="fetchCouponCodes">
                            </b-pagination>

                            <div class="d-flex flex-wrap align-items-center">
                                <div class="mr-3 mb-3">
                                    <span class="small">{{ dispPaginationDetail }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    v-else
                    class="d-flex justify-content-center align-items-center p-5">
                    <b-spinner variant="yokumiru-admin"/>
                </div>
            </div>
        </div>

        <admin-edit-coupon-code-modal/>
        <admin-delete-coupon-code-modal/>
    </div>
</template>

<script>
import {mapMutations} from 'vuex'
import constants from '../../constants'
import YokumiruHelper from '../../YokumiruHelper'

export default {
    name: 'AdminCouponCodes',

    data: function () {
        return {
            helper: YokumiruHelper,
            search: {
                coupon_id: null,
                freeword: null,
                created_at_gte: null,
                created_at_lte: null,
            },
            coupons: [],
            couponCodes: null,
            fields: [
                {
                    'key': 'id',
                    'label': '#',
                    sortable: true,
                },
                {
                    'key': 'code',
                    'label': 'クーポンコード',
                    sortable: true,
                },
                {
                    'key': 'is_enabled',
                    'label': '有効／無効',
                    sortable: true,
                },
                {
                    'key': 'coupon_name',
                    'label': 'クーポン名',
                    sortable: true,
                },
                {
                    'key': 'use_limit',
                    'label': '使用数上限',
                    sortable: true,
                },
                {
                    'key': 'user_coupons_count',
                    'label': '使用数',
                    sortable: false,
                },
                {
                    'key': 'remarks',
                    'label': '備考',
                    sortable: false,
                },
                {
                    'key': 'created_at',
                    'label': '作成日時',
                    sortable: true,
                },
                {
                    'key': 'links',
                    'label': '',
                    'class': 'text-center',
                    sortable: false,
                },
            ],
        }
    },

    computed: {
        /**
         * ページング詳細表示
         * @returns {string}
         */
        dispPaginationDetail: function () {
            if (this.$store.state.adminCouponCodes.total < 1) {
                return ''
            }

            return `全${this.$store.state.adminCouponCodes.total}件中 ${this.$store.state.adminCouponCodes.from}～${this.$store.state.adminCouponCodes.to}件表示`
        },
    },

    created: function () {
        this.initQueryFromState()
        this.initSearchCondition()
        this.fetchCouponCodes()
        this.fetchCoupons()

        bus.$on('coupon-code-edited', this.fetchCouponCodes)
        bus.$on('coupon-code-deleted', this.fetchCouponCodes)
    },

    beforeDestroy: function () {
        bus.$off('coupon-code-edited')
        bus.$off('coupon-code-deleted')
    },

    methods: {
        ...mapMutations({
            setQuery: 'adminCouponCodes/setQuery',
            setQueries: 'adminCouponCodes/setQueries',
        }),

        onChangeSearchCoupon: async function () {
            await this.setQuery({ key: 'coupon_id', value: this.search.coupon_id })
            await this.fetchCouponCodes(1)
        },

        onChangeSearchFreeword: async function () {
            await this.setQuery({ key: 'freeword', value: this.search.freeword })
            await this.fetchCouponCodes(1)
        },

        onChangeSearchCreatedAtGte: async function () {
            await this.setQuery({ key: 'created_at_gte', value: this.search.created_at_gte })
            await this.fetchCouponCodes(1)
        },

        onChangeSearchCreatedAtLte: async function () {
            await this.setQuery({ key: 'created_at_lte', value: this.search.created_at_lte })
            await this.fetchCouponCodes(1)
        },

        /**
         * クーポンコード一覧取得
         *
         * @param {number|object} param
         */
        fetchCouponCodes: async function (param = null) {
            this.couponCodes = null

            if (Number.isInteger(param) && param > 0) {
                await this.setQuery({ key: 'current_page', value: param })
            }
            else if (param !== null && param.hasOwnProperty('sortBy')) {
                await this.setQuery({ key: 'sortBy', value: param.sortBy })
                await this.setQuery({ key: 'sortDesc', value: param.sortDesc })
            }

            const endpoint = constants.admin.coupon_codes.endpoint.base

            axios.get(`${endpoint}${this.buildQuery()}`)
                .then(({data}) => {
                    this.couponCodes = data.data
                    this.setQueries(data.meta)
                })
        },

        /**
         * クーポン一覧取得
         */
        fetchCoupons: function () {
            axios.get(constants.admin.coupons.endpoint.base)
                .then(({data}) => {
                    this.coupons = data.data
                })
        },

        /**
         * 検索条件の初期化（localStorageから復元）
         */
        initQueryFromState: function () {
            if (localStorage.getItem('yokumiruWeb')) {
                const data = JSON.parse(localStorage.getItem('yokumiruWeb'))
                if (data.adminCouponCodes) {
                    this.setQueries(data.adminCouponCodes)
                }
            }
        },

        /**
         * 検索条件の初期化
         */
        initSearchCondition: function () {
            this.search.coupon_id = this.$store.state.adminCouponCodes.coupon_id
            this.search.freeword = this.$store.state.adminCouponCodes.freeword
        },

        /**
         * QueryString生成
         *
         * @param {boolean} paginate
         * @return {string}
         */
        buildQuery: function (paginate = true) {
            let query = '?'

            if (paginate) {
                query += `page=${this.$store.state.adminCouponCodes.current_page}`
                query += `&sort=${this.$store.state.adminCouponCodes.sortBy}`
                query += `&desc=${this.$store.state.adminCouponCodes.sortDesc}`
            }
            else {
                query += `sort=${this.$store.state.adminCouponCodes.sortBy}`
                query += `&desc=${this.$store.state.adminCouponCodes.sortDesc}`
            }

            query += `&coupon_id=${this.$store.state.adminCouponCodes.coupon_id || ''}`
            query += `&freeword=${this.$store.state.adminCouponCodes.freeword || ''}`
            query += `&created_at_gte=${this.$store.state.adminCouponCodes.created_at_gte || ''}`
            query += `&created_at_lte=${this.$store.state.adminCouponCodes.created_at_lte || ''}`

            return query
        },

        /**
         * クーポンコード編集モーダル
         * @param {object} couponCode
         */
        openModalAdminEditCouponCode: function (couponCode) {
            bus.$emit('open-modal-admin-edit-coupon-code', couponCode)
        },

        /**
         * クーポンコード削除モーダル
         * @param {object} couponCode
         */
        openModalAdminDeleteCouponCode: function (couponCode) {
            bus.$emit('open-modal-admin-delete-coupon-code', couponCode)
        },
    },
}
</script>

<style lang="scss">
.adminCouponCodesTableWrapper {
    table {
        tr {
            th {
                &:nth-child(6) {
                    width: 200px !important;
                }
            }
        }
    }
}
</style>

<style lang="scss" scoped>
.remarks {
    overflow-x: scroll;
    white-space: pre;
    width: 200px;
    padding: 8px 0;
    box-sizing: border-box;
    line-height: 0.8;
}
</style>
